import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/feedback-subject', { params })
  },
  store (formData) {
    return apiClient.post('/feedback-subject', formData)
  },
  show (id, params) {
    return apiClient.get(`/feedback-subject/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/feedback-subject/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/feedback-subject/${id}`)
  }
}
